import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

export const ServicesContext = createContext();

function ServicesContextProvider(props) {
  const [services, setServices] = useState();

  useEffect(() => {
    axios
      .get(`https://the-outlet-vendor-api.herokuapp.com/services`)
      .then((res) => {
        setServices(res && res.data);
      })
      .catch((err) => {
        console.log(err.response.data.error);
      });
  }, []);

  return (
    <ServicesContext.Provider value={{ services }}>
      {props.children}
    </ServicesContext.Provider>
  );
}

export default ServicesContextProvider;
